import React from 'react'

import { SvgIcon } from '../svg-icon'

/**
 * Define default props as fallback. See SvgIcon base class for propTypes.
 *
 * @static
 * @type {React.defaultProps}
 */
const defaultProps = {
    viewBoxSize: 48
}

const iconPath = `M21.2,42c-.1,0-.22-.02-.32-.06-.44-.16-.72-.6-.66-1.08l1.64-12.86h-6.86c-.36,0-.7-.2-.86-.5-.18-.32-.18-.7,0-1L25.94,6.49c.24-.4,
.74-.58,1.18-.44,.44,.16,.72,.6,.66,1.08l-1.64,12.86h6.86c.36,0,.68,.2,.86,.5,.18,.32,.18,.7,0,1l-11.8,20.01c-.18,.32-.52,.5-.86,.5Z`

/**
 * Stateless function returning SVG icon with single bolt inside.
 *
 * @function
 * @param {Object} [props] The component properties
 * @returns {ReactElement} React component markup
 *
 * @see SvgIcon
 * @example
 * <SingleBoltIcon width={12} />
 */
const SingleBoltIcon = props => (
    <SvgIcon {...props}>
        <path d={iconPath} />
    </SvgIcon>
)

SingleBoltIcon.defaultProps = defaultProps

export { SingleBoltIcon }
